import * as Sentry from '@sentry/react-native';

export class HttpClientError extends Error {
  status: number;
  url: string;

  constructor(url: string, status: number, statusText: string) {
    super(`HTTP ${status} ${statusText} — ${url}`);
    this.name = 'HttpClientError';
    this.status = status;
    this.url = url;
  }
}

export const fetchWithErrorHandling = async (
  url: string,
  options?: RequestInit
): Promise<Response> => {
  const response = await fetch(url, options);
  if (!response.ok) {
    let bodySnippet = '';
    try {
      const text = await response.text();
      bodySnippet = text.slice(0, 200);
    } catch {
      // ignore body read failures
    }
    Sentry.addBreadcrumb({
      category: 'http',
      message: `Non-2xx response: ${response.status} ${response.statusText}`,
      data: { url, status: response.status, body: bodySnippet },
      level: 'error',
    });
    throw new HttpClientError(url, response.status, response.statusText);
  }
  return response;
};
